import { sentryConfig as defaultSentryConfig } from './Config.base';
export * from './Config.base';

export const sentryConfig = {
    ...defaultSentryConfig,
    environment: 'test',
    debug: false
};

export const LookUpServerUrl = 'https://apitest.visionslive.com/VL/focusGroupsRouter/getServerUri?token=';
export const growthbookApiKey = 'sdk-jI7F11sqYilbQO';